import React, { useState, useEffect } from 'react';
import { Button, Cascader, Table, message, Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import addressOptions from 'china-division/dist/pca.json';

// 转换省市区数据为 Cascader 所需的格式
const cascaderOptions = Object.keys(addressOptions).map(province => ({
  value: province,
  label: province,
  children: Object.keys(addressOptions[province]).map(city => ({
    value: city,
    label: city,
    children: addressOptions[province][city].map(district => ({
      value: district,
      label: district
    }))
  }))
}));

const CampusSelector = ({ value = [], onChange = () => {} }) => {
  const [campuses, setCampuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterAddress, setFilterAddress] = useState([]);

  const { apiClient } = useAuth();

  useEffect(() => {
    fetchCampuses();
  }, []);

  const fetchCampuses = async () => {
    if (!apiClient) {
      message.error('系统初始化中，请稍后重试');
      return;
    }

    setLoading(true);
    try {
      const response = await apiClient.get('/sports-base-server-prod/myPage/searchCustomer', {
        params: { pageNum: 1, pageSize: 99999 }
      });

      if (response.data && response.data.result === '1') {
        const list = response.data.customerList || [];
        setCampuses(list);
      } else {
        message.error(response.data?.msg || '获取校区列表失败');
      }
    } catch (error) {
      console.error('获取校区列表错误:', error);
      message.error('获取校区列表失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const filteredCampuses = campuses.filter(campus =>
    !filterAddress.length || (campus.customerAddress && campus.customerAddress.startsWith(filterAddress.join(' ')))
  );

  const dataSource = filteredCampuses;

  // 获取选中校区的名称
  const selectedCampusNames = () => {
    const selectedIds = Array.isArray(value) ? value : value.split(';').filter(id => id);
    const selectedNames = selectedIds.map(id => {
      const campus = campuses.find(c => String(c.customerId) === String(id));
      return campus ? campus.customerName : '';
    }).filter(name => name !== '');
    
    return selectedNames.join('; ');
  };

  const rowSelection = {
    selectedRowKeys: Array.isArray(value) ? value : value.split(';').filter(id => id),
    onChange: (keys, rows) => {
      onChange((Array.isArray(keys) ? keys : []).join(';'));
    },
  };

  const columns = [
    {
      title: '校区名称',
      dataIndex: 'customerName',
      key: 'customerName',
    },
    {
      title: '校区地址',
      dataIndex: 'customerAddress',
      key: 'customerAddress',
    },
  ];

  // 计算表格容器的高度，假设每行大约50px，标题栏和其他元素约占用100px
  const tableHeight = 6 * 50 + 100; // 显示6行数据的高度

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <span style={{ marginRight: 8 }}>已限定校区:</span>
        <span style={{ fontWeight: 'bold', color: '#1890ff' }}>{selectedCampusNames() || '无'}</span>
      </div>
      
      <Cascader
        options={cascaderOptions}
        placeholder="请选择省市区进行过滤"
        value={filterAddress}
        onChange={setFilterAddress}
        style={{ marginBottom: 16 }}
      />

      <Table
        rowSelection={rowSelection}
        dataSource={dataSource}
        columns={columns}
        rowKey="customerId"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowClassName={(record) => {
          const selectedIds = Array.isArray(value) ? value : value.split(';').filter(id => id);
          return selectedIds.includes(String(record.customerId)) ? 'selected-row' : '';
        }}
      />
      <style dangerouslySetInnerHTML={{ __html: '.selected-row { background-color: #e6f7ff; }' }} />
    </>
  );
};

export default CampusSelector;